<template>
  <section class="section-main">
    <div class="main-header">
      <router-link
        to="/master/coupons"
        exact
        tag="li"
        :title="'Voltar'"
        class="back_btn"
        v-tippy="{
          placement: 'right',
          theme: 'light',
          inertia: true,
          arrow: true,
          animation: 'perspective',
        }"
      >
        <fa size="lg" icon="arrow-left"></fa>
      </router-link>
      <div class="header-title">CRIAR CUPOM DE DESCONTO</div>
    </div>
    <div class="wrap">
      <div class="form-div">
        <div>
          <div class="padding-0">Nome</div>
          <input type="text" class="input" v-model="name" />
        </div>
        <div>
          <div class="flex w-100 padding-0">
            <div class="w-45 padding-0">
              <div class="padding-0">Valor</div>
              <input type="number" class="input" v-model="amount" />
            </div>
            <div class="w-45">
              <div class="padding-0">Quantidade</div>
              <input type="number" class="input" v-model="quantity" />
            </div>
          </div>
        </div>
        <div class="w-30">
          <div class="padding-0">Data de Expiração</div>
          <input
            type="date"
            class="input"
            v-model="expirationDate"
            :min="new Date().toISOString().split('T')[0]"
          />
        </div>
        <div class="w-30">
          <div class="padding-0">Hora de Expiração</div>
          <input type="time" class="input" v-model="time" />
        </div>
        <div class="w-30">
          <div class="padding-0">Valor mínimo</div>
          <input type="number" class="input" v-model="minRequestAmount" />
        </div>
      </div>
      <div class="submit_div">
        <button @click="checkFileds()" type="submit" class="btn button-gradient">Cadastrar</button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ZepplinCouponsAPI from "../../../api/zepplin/coupons";
import moment from "moment";
import * as yup from "yup";

export default {
  data() {
    return {
      name: "",
      amount: 0.0,
      expirationDate: "",
      expirationTime: "12:00",
      time: "12:00",
      quantity: 0,
      minRequestAmount: 0.0
    };
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),

    async saveCoupon() {
      await ZepplinCouponsAPI.store(
        {
          masterToken: this.zepplinMasterToken
        },
        {
          name: this.name,
          amount: parseFloat(this.amount),
          expirationDate: new Date(
            this.expirationDate + " " + this.expirationTime
          ).toISOString(),
          quantity: this.quantity,
          minRequestAmount: parseFloat(this.minRequestAmount)
        }
      ).then(res => {
        console.log(res);
        this.showToast({
          type: "success",
          message: "Operação realizada com sucesso!"
        });
        this.$router.push("/master/coupons");
      });
    },

    async checkFileds() {
      await schema
        .validate({
          name: this.name,
          amount: this.amount,
          minRequestAmount: this.minRequestAmount,
          expirationDateString: this.expirationDate,
          quantity: this.quantity
        })
        .then(async () => {
          await dateValidation
            .validate(new Date(this.expirationDate))
            .then(() => {
              if (
                moment().isAfter(
                  new Date(this.expirationDate + " " + this.time)
                )
              ) {
                this.showError(
                  "Este horário já passou, por favor escolha outro!"
                );
              } else {
                this.expirationTime = this.time;
                this.saveCoupon();
              }
            })
            .catch(err => this.showError(err.message));
        })
        .catch(err => this.showError(err.message));
    }
  },
  computed: {
    ...mapState("auth", ["zepplinMasterToken"])
  }
};

const schema = yup.object().shape({
  name: yup.string().required("Campo nome requerido"),
  amount: yup
    .number("Campo 'Valor mínimo' inválido")
    .min(0.1, "O campo valor deve ser maior que 0")
    .required("Campo 'Valor mínimo' requerido"),
  minRequestAmount: yup
    .number("Digite um valor válido")
    .min(0.1, "O campo valor mínimo deve ser maior que 0")
    .required("Campo valor mínimo requerido"),
  expirationDateString: yup
    .string("Selecione uma data válida")
    .required("Campo expiração requerido"),
  quantity: yup
    .number("Digite uma quantidade válida")
    .min(0.1, "O campo quantidade deve ser maior que 0")
    .required("Campo quantidade requerido")
});

const date = new Date();

const dateValidation = yup
  .date()
  .min(
    new Date(
      `${date.getFullYear()}-${
        date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth()
      }-${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`
    ).toISOString(),
    "Data inválida"
  )
  .max(new Date("3000-01-02"), "Data inválida");
</script>

<style scoped>
.section-main {
  padding: 70px;
  width: 100%;
  background-color: var(--bg-color--2);
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.main-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.header-title {
  display: flex;
  font-weight: 600;
}

.back_btn {
  background-color: red;
  list-style: none;
  padding: 10px;
  border-radius: 50%;
  background: linear-gradient(89.39deg, #0072e4 -0.59%, #25a0a8 100.95%);
  color: #fff;
  cursor: pointer;
}

.wrap {
  width: 100%;
  margin-top: 40px;
}

.input {
  border-bottom: 1px solid #525662;
}

input {
  margin-bottom: 20px;
  text-transform: none;
}

.form-div {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
}

.form-div div {
  width: 50%;
  padding: 0px 10px;
}

.submit_div {
  display: flex;
  justify-content: flex-end;
}

.button-gradient {
  width: 150px;
}

.w-30 {
  width: 30% !important;
}

.w-45 {
  width: 45% !important;
}

.w-100 {
  width: 100% !important;
}

.padding-0 {
  padding: 0 !important;
}
</style>
